/**
 * DrawerContainer - slide-in drawer wrapper (menus, cart, filters).
 * Custom element: <drawer-container>
 *
 * Attributes (from $info):
 *   use-overlay  Boolean  -
 *
 * Refs:
 *   [data-ref="drawerHeader"]  (optional)
 *   [data-ref="drawerContent"]  (optional)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import "./component-DrawerHeader.js";
import "./component-BodyOverlay.js";
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class DrawerContainer extends ThemeComponent {
  constructor() {
    super(...arguments), this.focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', this.previousFocus = document.body, this.bodyOverlay = null;
  }
  init() {
    this.bodyOverlay = document.querySelector(".body-overlay"), this.bodyOverlay && this.$subscribe(this.bodyOverlay.onCloseChange, () => {
      this.close();
    }), this.setAttribute("aria-hidden", "true"), this.$subscribe(this.drawerHeader.onCloseChange, () => {
      this.close();
    }), document.addEventListener("overlay-clicked", () => this.close());
  }
  handleFocusLock() {
    const firstFocusable = this.querySelectorAll(this.focusableElements)[0],
      focusables = this.querySelectorAll(this.focusableElements),
      lastFocusable = focusables[focusables.length - 1];
    document.addEventListener("keydown", keydownEvent => {
      (keydownEvent.key === "Tab" || keydownEvent.keyCode === 9) && (keydownEvent.shiftKey ? document.activeElement === firstFocusable && (keydownEvent.preventDefault(), lastFocusable.focus()) : (firstFocusable === lastFocusable && (keydownEvent.preventDefault(), firstFocusable.focus()), document.activeElement === lastFocusable && (keydownEvent.preventDefault(), firstFocusable.focus())));
    }), setTimeout(() => {
      firstFocusable.focus();
    }, 300);
  }
  open() {
    var overlay;
    document.activeElement && (this.previousFocus = document.activeElement), this.useOverlay && ((overlay = this.bodyOverlay) == null || overlay.openOverlay()), document.body.classList.add("prevent-scroll"), this.setAttribute("open", ""), this.setAttribute("aria-hidden", "false"), this.handleFocusLock();
  }
  close() {
    var overlayForClose;
    const focusToRestore = this.previousFocus;
    this.useOverlay && ((overlayForClose = this.bodyOverlay) == null || overlayForClose.closeOverlay()), document.body.classList.remove("prevent-scroll"), this.removeAttribute("open"), this.setAttribute("aria-hidden", "true"), focusToRestore.focus();
  }
}
setFunctionName(DrawerContainer, "DrawerContainer");
const propertyTypes = {
  Boolean
};
DrawerContainer.prototype.$name = "DrawerContainer";
DrawerContainer.prototype.$info = JSON.parse('{"name":"DrawerContainer","meta":{"isLegacy":false,"selector":"drawer-container"},"props":[{"attr":"use-overlay","reflectAttr":false,"propertyKey":"useOverlay","propertyType":"Boolean","propertyTypeName":"Boolean","propertyTsTypeName":"boolean"}],"refs":[{"selector":"[data-ref=\\"drawerHeader\\"]","required":false,"propertyKey":"drawerHeader","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"DrawerHeader"},{"selector":"[data-ref=\\"drawerContent\\"]","required":false,"propertyKey":"drawerContent","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLElement"}]}');
DrawerContainer.prototype.$info.component = DrawerContainer;
for (const prop of DrawerContainer.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Drawer/DrawerContainer.ts", {
  DrawerContainer: DrawerContainer
}, void 0);